import { Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { EmptyHeaderComponent } from '../../../components/datatable/components/empty/empty-header.component';
import { IconComponent } from '../../../components/icon/icon.component';
import { EmptyComponent } from '../../../components/datatable/components/empty/empty.component';
import { EmptySubHeaderComponent } from '../../../components/datatable/components/empty/empty-sub-header.component';

@Component({
  selector: 'td-wb-learn-no-result',
  templateUrl: 'learn-no-result.component.html',
  imports: [
    TranslateDirective,
    EmptyComponent,
    EmptyHeaderComponent,
    EmptySubHeaderComponent,
    IconComponent
  ]
})
export class LearnNoResultComponent {
}

